import { EyeOutlined, UploadOutlined } from "@ant-design/icons";
import { Button, Upload } from "antd";
import React, { FC, useEffect, useState } from "react";
import { Document } from "../../../PreAuth/PreAuthIhx/PreAuthIhx";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../store/store";

type DischargeDocumentUploadProps = {
  documentTypes: Document[];
  documentUrls: {
    documentType: string;
    documentName: string;
    documentUrl: string;
    id: number;
    referenceType: string | null;
    documentLabelType: any;
    deficiencyCheckStatus: any;
    remarks: string | null;
  }[];
  handleFileChange: any;
  handleOpen: any;
  documentRequestResponseDocuments: any;
  portalSubmission: boolean;
  isApproved: boolean;
  uploadFileList: any;
  isIntimated: any;
  isEchsScheme?: any;
};

const DischargeDocumentUpload: FC<DischargeDocumentUploadProps> = ({
  documentTypes,
  documentUrls,
  handleFileChange,
  handleOpen,
  documentRequestResponseDocuments,
  portalSubmission,
  isApproved,
  uploadFileList,
  isIntimated,
  isEchsScheme,
}) => {
  const [updatedDocumentUrls, setUpdatedDocumentUrls] = useState<any>();
  const { auth, patients } = useSelector((state: RootState) => state);

  useEffect(() => {
    const uploadedDocumentUrls: any = documentUrls?.filter((document: any) =>
      documentRequestResponseDocuments["requestedDocuments"]?.some(
        (doc: any) => doc?.label === document?.documentLabelType,
      ),
    );

    setUpdatedDocumentUrls(uploadedDocumentUrls);
  }, [documentRequestResponseDocuments, documentUrls]);

  const groupByLabelType = (docs: any[]) => {
    return docs?.reduce((acc: any, doc: any) => {
      const label = doc.documentLabelType;
      if (!acc[label]) acc[label] = [];
      acc[label].push(doc);
      return acc;
    }, {});
  };

  return (
    <div>
      <div
        style={{
          textDecoration:
            patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
            "ECHS"
              ? "none"
              : "underline",
          fontSize: "16px",
          margin: "16px 0",
          fontWeight: "bold",
        }}
      >
        {patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
        "ECHS" ? (
          <div style={{ color: "red", textDecoration: "none" }}>
            Please Upload Digitally Signed Documents
          </div>
        ) : (
          <div>Request Document Upload</div>
        )}
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(6, 1fr)", //repeat(auto-fit, minmax(300px, 1fr))
          gap: 10,
        }}
      >
        {documentRequestResponseDocuments?.["requestedDocuments"]?.length > 0 &&
          documentRequestResponseDocuments?.["requestedDocuments"]?.map(
            (docType: any) => {
              const matchingDocuments = documentUrls?.filter(
                (doc) => doc.documentLabelType === docType.label,
              );

              if (matchingDocuments?.length > 0 && !docType?.multiple) {
                return null;
              }

              return (
                <div
                  key={docType.id}
                  style={{
                    border: "1px solid #eee",
                    padding: 10,
                    borderRadius: 8,
                    display: "flex",
                    alignItems: "center",
                    // gap: 8,
                  }}
                >
                  {matchingDocuments?.length > 0 && !docType?.multiple ? (
                    <p></p>
                  ) : (
                    <Upload
                      multiple={docType?.multiple}
                      {...(docType?.multiple
                        ? { fileList: uploadFileList }
                        : {})}
                      showUploadList={false}
                      beforeUpload={() => false}
                      onChange={
                        handleFileChange &&
                        handleFileChange(docType?.labelId, docType?.multiple)
                      }
                      disabled={portalSubmission}
                    >
                      <Button
                        icon={<UploadOutlined />}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          borderRadius: 0,
                          border: "none",
                          borderTopLeftRadius: "6px",
                          borderBottomLeftRadius: "6px",
                        }}
                        // disabled={(auth?.role?.role === "FO_STAFF" && isIntimated) || portalSubmission || isApproved}
                        disabled={
                          isEchsScheme &&
                          (docType.label === "HOSPITAL BILL" ||
                            docType.label === "BILL SUMMARY" ||
                            docType.label === "DISCHARGE SUMMARY" || docType?.label?.toUpperCase() === "AUDIT REPORT")
                            ? true
                            : portalSubmission
                        }
                        // disabled={portalSubmission}
                      ></Button>
                    </Upload>
                  )}
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Button
                      style={{
                        borderRadius: 0,
                        border: "none",
                        paddingLeft: 4,
                        borderTopRightRadius: "6px",
                        borderBottomRightRadius: "6px",
                      }}
                      iconPosition={"end"}
                      // icon={
                      //   matchingDocuments?.length > 0 ? (
                      //     <EyeOutlined
                      //       style={{ marginLeft: "0.6rem" }}
                      //       onClick={() => {
                      //         handleOpen(
                      //           matchingDocuments?.[0]?.documentLabelType
                      //         );
                      //       }}
                      //     />
                      //   ) : (
                      //     <></>
                      //   )
                      // }
                    >
                      {docType.label}{" "}
                      {docType?.required ? (
                        <span style={{ color: "red" }}>*</span>
                      ) : (
                        <></>
                      )}
                    </Button>
                  </div>

                  {/* {matchingDocuments?.length > 0 && (
                <EyeOutlined
                  style={{ marginLeft: "0.6rem" }}
                  onClick={() => {
                    handleOpen();
                  }}
                />
              )} */}
                </div>
              );
            },
          )}

        {/* {
          documentUrls?.map((docType) => (
            <div
              key={docType.id}
              style={{
                border: "1px solid #eee",
                padding: 10,
                borderRadius: 8,
                display: "flex",
                alignItems: "center",
                // gap: 8,
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Button
                  style={{
                    borderRadius: 0,
                    border: "none",
                    paddingLeft: 0,
                    borderTopRightRadius: "6px",
                    borderBottomRightRadius: "6px",
                  }}
                  iconPosition={"end"}
                  icon={
                    docType?.documentLabelType?.length > 0 ? (
                      <EyeOutlined
                        style={{ marginLeft: "0.6rem" }}
                        onClick={() => {
                          handleOpen(docType?.documentLabelType);
                        }}
                      />
                    ) : (
                      <></>
                    )
                  }
                >
                  {docType.documentLabelType}{" "}
                </Button>
              </div>
            </div>
          ))
        } */}
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)",
          gap: 10,
          borderTop:
            updatedDocumentUrls?.length > 0 ? "1px solid gray" : "none",
        }}
      >
        {Object.entries(groupByLabelType(updatedDocumentUrls || []))?.map(
          ([labelType, docs]: [any, any]) =>
            docs.map((docType: any, idx: any) => (
              <div
                key={docType.id}
                style={{
                  border: "1px solid #eee",
                  padding: 10,
                  borderRadius: 8,
                  display: "flex",
                  alignItems: "center",

                  // gap: 8,
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Button
                    style={{
                      borderRadius: "6px",
                      border: "none",
                      paddingLeft: 20,
                      // borderTopRightRadius: "6px",
                      // borderBottomRightRadius: "6px",
                      background: docType?.deficiencyCheckStatus
                        ? "rgb(0, 109, 119)"
                        : docType?.deficiencyCheckStatus === "false" ||
                            docType?.deficiencyCheckStatus === false
                          ? "#DD2025"
                          : "#fff",
                      color:
                        docType?.deficiencyCheckStatus ||
                        docType?.deficiencyCheckStatus === false
                          ? "white"
                          : "black",
                    }}
                    iconPosition={"end"}
                    icon={
                      <EyeOutlined
                        style={{ marginLeft: "0.6rem" }}
                        onClick={() => {
                          handleOpen(
                            docType?.documentLabelType,
                            docType?.documentUrl,
                          );
                        }}
                      />
                    }
                  >
                    {docType?.documentLabelType} {idx + 1}{" "}
                  </Button>
                </div>
              </div>
            )),
        )}
      </div>
    </div>
  );
};

export default DischargeDocumentUpload;
